// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oboGN","content":"styles_content__dN6Uw","tableWrap":"styles_tableWrap__tTeyL"};